import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { FACTOR_OPTIONS } from '@/pages/instruments/new-instrument/constants/factors'

export interface FactorFormFieldProps {}

export const FactorFormField: React.FC<FactorFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ factor: string | null }>()

  return (
    <FormField
      name="factor"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Factor</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone="None"
              placeholder={'Select a factor...'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('factor', value ? value : null, { shouldValidate: true })
              }
              options={FACTOR_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
